<div
  [ngClass]="{
    'secondary-background': backgroundColor === 'SECONDARY',
    'white-background': backgroundColor === 'WHITE',
    'transparent-background': backgroundColor === 'TRANSPARENT',
  }"
  class="safe-area-top-container"></div>
